import { Suspense } from "react";
import { Box } from "@mui/material";
import { SubAppSkeleton } from "shell/components/SubAppSkeleton";
import { useTranslation } from "react-i18next";
import { ResizableContainer } from "../../shell/components/ResizeableContainer";
import { Sidebar } from "./components/Sidebar";
import { Route, Switch } from "react-router";
import { AllBlocks } from "./views/AllBlocks";
import { BlockModel } from "./views/BlockModel";
import { BlockItem } from "./views/BlockItem";
export const BlocksApp = () => {
  return <Suspense fallback={<SubAppSkeleton />} data-sentry-element="Suspense" data-sentry-component="BlocksApp" data-sentry-source-file="index.tsx">
      <BlocksAppInner data-sentry-element="BlocksAppInner" data-sentry-source-file="index.tsx" />
    </Suspense>;
};
const BlocksAppInner = () => {
  // "schema" is hoisted here because Sidebar and AllBlocks import ModelList,
  // CreateModelDialogue, and NoResults from the schema app — all of which
  // resolve keys under the schema namespace and need it pre-loaded.
  useTranslation(["blocks", "schema"]);
  return <Box sx={{
    color: "text.primary",
    backgroundColor: "background.paper",
    height: "100%",
    display: "flex",
    "*": {
      boxSizing: "border-box"
    }
  }} data-sentry-element="Box" data-sentry-component="BlocksAppInner" data-sentry-source-file="index.tsx">
      <ResizableContainer id="blocksNav" defaultWidth={220} minWidth={220} maxWidth={360} data-sentry-element="ResizableContainer" data-sentry-source-file="index.tsx">
        <Sidebar data-sentry-element="Sidebar" data-sentry-source-file="index.tsx" />
      </ResizableContainer>
      <Switch data-sentry-element="Switch" data-sentry-source-file="index.tsx">
        <Route exact path="/blocks" render={() => <AllBlocks />} data-sentry-element="Route" data-sentry-source-file="index.tsx" />
        <Route path="/blocks/:modelZUID/new" render={({
        match
      }) => <BlockItem isCreate key={match.params.modelZUID} />} data-sentry-element="Route" data-sentry-source-file="index.tsx" />
        <Route path="/blocks/:modelZUID/:itemZUID" data-sentry-element="Route" data-sentry-source-file="index.tsx">
          <BlockItem data-sentry-element="BlockItem" data-sentry-source-file="index.tsx" />
        </Route>
        <Route path="/blocks/:modelZUID" render={({
        match
      }) => <BlockModel key={match.params.modelZUID} />} data-sentry-element="Route" data-sentry-source-file="index.tsx" />
      </Switch>
    </Box>;
};